export const paginationField = 'pagination-number-field';
